import script from "./SharedToast.vue?vue&type=script&setup=true&lang=ts"
export * from "./SharedToast.vue?vue&type=script&setup=true&lang=ts"

import "./SharedToast.vue?vue&type=style&index=0&id=9132f7f8&lang=postcss"

const __exports__ = script;

export default __exports__